import { SalesIntelList } from "./SalesIntelList";

export default {
  list: SalesIntelList,
};
